import { defineComponent as _defineComponent } from 'vue'
import type { SnowplowContext } from '@/helpers/tracking/providers';
import type { StreamingChartModuleFragment } from '@/features/onboarded-home/types';

import { TitleTrend } from '@/@types/graphql-types';

import PictureComp from '@/components/picture/PictureComp.vue';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons';

import { usePosterImpressionTracking } from '@/helpers/composables/usePosterImpressionTracking';

import { computed } from 'vue';

type StreamingChartTitle =
	StreamingChartModuleFragment['packagesWithTitles'][number]['titlesWithTrend'][number]['title'];


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamingChartListItem',
  props: {
    title: null,
    position: null,
    trend: null,
    additionalContexts: null
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props as {
	title: StreamingChartTitle;
	position: number;
	trend?: TitleTrend;
	additionalContexts?: SnowplowContext[];
};





const titleName = computed(() =>
	props.title.__typename === 'Season' ? props.title.show.content.title : props.title.content.title
);

// Returns the number of digits in a number, capped between 1 and 4
const positionDigits = computed(() => Math.min(Math.floor(Math.max(0, Math.log10(props.position))) + 1, 4));

const { onVisibilityChanged } = usePosterImpressionTracking({
	additionalContexts: () => props.additionalContexts ?? [],
});

return { __sfc: true,props, titleName, positionDigits, onVisibilityChanged, TitleTrend, PictureComp, TitleDetailLink, faCaretUp }
}

})